import BlockIcon from './BlockIcon';

export default BlockIcon;
